import React from 'react';
import PropTypes from 'prop-types';
import style from './Banner.scss';

const Banner = ({ content }) => !!content
  && (
    <div className={`${style.banner} pad-1 dls-color-neutral-bg dls-white font-weight-bold position-absolute`}>
      <p>{content}</p>
    </div>
  );
Banner.propTypes = {
  content: PropTypes.string,
};

Banner.defaultProps = {
  content: '',
};

export default Banner;
